import { render, staticRenderFns } from "./SyncToMeliArticle.vue?vue&type=template&id=0a3bb965&"
import script from "./SyncToMeliArticle.vue?vue&type=script&lang=js&"
export * from "./SyncToMeliArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports